export const baseUrl = process.env.REACT_APP_BASE_URL;

export const callGetAPI = async (path) => {
    const response = await fetch(baseUrl + path, {
        method: 'GET', headers: {
            'Accept-Language': '',
            'api-key': 'mzVYGK/ppHwkLZBwKoNjqA==',
            'Content-Type': 'application/json'
        }
    });

    const data = await response.json();
    return data;
}
